/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type AcceptClusterInviteAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class AcceptClusterInviteAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteAuthClusterResponse429ResponseBodyData;

  constructor(
    err: AcceptClusterInviteAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AcceptClusterInviteAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type AcceptClusterInviteAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class AcceptClusterInviteAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteAuthClusterResponse409ResponseBodyData;

  constructor(
    err: AcceptClusterInviteAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AcceptClusterInviteAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type AcceptClusterInviteAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class AcceptClusterInviteAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteAuthClusterResponse404ResponseBodyData;

  constructor(
    err: AcceptClusterInviteAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AcceptClusterInviteAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type AcceptClusterInviteAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class AcceptClusterInviteAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteAuthClusterResponseResponseBodyData;

  constructor(
    err: AcceptClusterInviteAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AcceptClusterInviteAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type AcceptClusterInviteAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class AcceptClusterInviteAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteAuthClusterResponseBodyData;

  constructor(
    err: AcceptClusterInviteAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AcceptClusterInviteAuthClusterResponseBody";
  }
}

/**
 * Bad request. `code: "reserved_org_slug"` distinguishes a slug that nobody may hold from the 409 returned when another org already holds it.
 */
export type AcceptClusterInviteResponseBodyData = {
  message: string;
  code?: string | undefined;
};

/**
 * Bad request. `code: "reserved_org_slug"` distinguishes a slug that nobody may hold from the 409 returned when another org already holds it.
 */
export class AcceptClusterInviteResponseBody extends SDKError {
  code?: string | undefined;

  /** The original data that was passed to this error instance. */
  data$: AcceptClusterInviteResponseBodyData;

  constructor(
    err: AcceptClusterInviteResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    if (err.code != null) this.code = err.code;

    this.name = "AcceptClusterInviteResponseBody";
  }
}

/** @internal */
export const AcceptClusterInviteAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AcceptClusterInviteAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AcceptClusterInviteAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AcceptClusterInviteAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    AcceptClusterInviteAuthClusterResponse429ResponseBody
  > = z.instanceof(AcceptClusterInviteAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AcceptClusterInviteAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AcceptClusterInviteAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AcceptClusterInviteAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AcceptClusterInviteAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    AcceptClusterInviteAuthClusterResponse409ResponseBody
  > = z.instanceof(AcceptClusterInviteAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AcceptClusterInviteAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AcceptClusterInviteAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AcceptClusterInviteAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AcceptClusterInviteAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    AcceptClusterInviteAuthClusterResponse404ResponseBody
  > = z.instanceof(AcceptClusterInviteAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AcceptClusterInviteAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AcceptClusterInviteAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AcceptClusterInviteAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AcceptClusterInviteAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    AcceptClusterInviteAuthClusterResponseResponseBody
  > = z.instanceof(AcceptClusterInviteAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AcceptClusterInviteAuthClusterResponseBody$inboundSchema:
  z.ZodType<AcceptClusterInviteAuthClusterResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new AcceptClusterInviteAuthClusterResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type AcceptClusterInviteAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AcceptClusterInviteAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    AcceptClusterInviteAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    AcceptClusterInviteAuthClusterResponseBody
  > = z.instanceof(AcceptClusterInviteAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AcceptClusterInviteResponseBody$inboundSchema: z.ZodType<
  AcceptClusterInviteResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  code: z.string().optional(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new AcceptClusterInviteResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type AcceptClusterInviteResponseBody$Outbound = {
  message: string;
  code?: string | undefined;
};

/** @internal */
export const AcceptClusterInviteResponseBody$outboundSchema: z.ZodType<
  AcceptClusterInviteResponseBody$Outbound,
  z.ZodTypeDef,
  AcceptClusterInviteResponseBody
> = z.instanceof(AcceptClusterInviteResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
    code: z.string().optional(),
  }));
